// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datetime {
  width: fit-content;
}

ion-popover {
  --width: auto;
}

ion-item {
  --padding-start: 0px;
  border: 1px solid black;
}

ion-datetime {
  max-width: 100%;
}

.summary-date-header {
  background-color: var(--ion-color-dark-shade);
  color: var(--ion-color-light);
}

.summary-table-rows {
  border-bottom: 1px solid var(--ion-color-light-shade);
}
.summary-table-rows ion-col {
  background-color: var(--ion-color-light);
  border-left: 1px solid var(--ion-color-light-shade);
  text-transform: capitalize !important;
  padding: 3px 0 !important;
  padding-right: 10px !important;
  align-content: center;
}
.summary-table-rows .border-right {
  border-right: 1px solid var(--ion-color-light-shade);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/account-summary/account-summary.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,oBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,6CAAA;EACA,6BAAA;AACJ;;AAEA;EASI,qDAAA;AAPJ;AADI;EACI,wCAAA;EACA,mDAAA;EACA,qCAAA;EACA,yBAAA;EACA,8BAAA;EACA,qBAAA;AAGR;AACI;EACI,oDAAA;AACR","sourcesContent":[".datetime {\n    width: fit-content;\n}\n\nion-popover {\n    --width: auto;\n}\n\nion-item {\n    --padding-start: 0px;\n    border: 1px solid black;\n}\n\nion-datetime {\n    max-width: 100%;\n}\n\n.summary-date-header {\n    background-color: var(--ion-color-dark-shade);\n    color: var(--ion-color-light);\n}\n\n.summary-table-rows {\n    ion-col {\n        background-color: var(--ion-color-light);\n        border-left: 1px solid var(--ion-color-light-shade);\n        text-transform: capitalize !important;\n        padding: 3px 0 !important;\n        padding-right: 10px !important;\n        align-content: center;\n    }\n    border-bottom: 1px solid var(--ion-color-light-shade);\n\n    .border-right {\n        border-right: 1px solid var(--ion-color-light-shade);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
